<div *ngIf="!modalData.isEdit" [formGroup]="multipleChoiceForm" class="mt-1">
  <div class="form-group row">
    <label class="col-2 col-form-label">คำถาม<lifedi-require></lifedi-require></label>
    <div class="col-9">
      <input type="text" class="form-control" id="question" formControlName="question" autocomplete="off"
        ngDefaultControl>
      <!-- <small *ngIf="!form.get('question').valid &&  form.get('question').touched"
        class="text-danger">
        กรุณากรอกข้อมูล
      </small> -->
      <span *ngIf="multipleChoiceForm.value.media?.file_name">
        <span style="display: inline;">
          {{ multipleChoiceForm.value.media.file_name }}
        </span>
        <button mat-icon-button style="display: inline;" (click)="deleteImgQuestion(multipleChoiceForm)">
          <span class="text-danger">✖</span>
        </button>
      </span>
    </div>
    <div class="col-1">
      <button mat-mini-fab class="img" (click)="fileInput.click()" style="border-radius: 0; box-shadow: none;"
        [style.backgroundImage]="'url(\'../../../../assets/multimedia.png\')'">
        <input #fileInput type="file" accept=".png, .jpg, .jpeg, .mp4, .mp3, .wav"
          (change)="addQuestionMedia($event, multipleChoiceForm)" style="display:none;" />
      </button>
    </div>
  </div>
  <div
    *ngIf="questionMediaType === 'mp4' || questionMediaType === 'mp3' || questionMediaType === 'wav' || questionMediaType === 'vdo' || questionMediaType === 'sound'"
    class="form-group row" formGroupName="media">
    <label class="col-6 col-form-label">จำนวนรอบที่วิดีโอ/เสียงสามารถเปิดซ้ำได้<lifedi-require></lifedi-require></label>
    <div class="col-2">
      <input [attr.disabled]="multipleChoiceForm.value.media.unlimit ? true : null" class="form-control"
        formControlName="time_again" type="number" min="0" width="100px"
        (change)="setTimeAgain(multipleChoiceForm, $event)">
    </div>
    <div class="col">
      <mat-checkbox id="unlimit" class="col-form-label" color="primary" formControlName="unlimit"
        (click)="clearValueDate(multipleChoiceForm)">
        ไม่จำกัดรอบ
      </mat-checkbox>
    </div>
  </div>

  <div *ngFor="let c of multipleChoiceFormArray.controls; let i = index" formArrayName="choices">
    <div [formGroupName]="i" class="form-group row">
      <label class="col-1 col-form-label">C{{ i+1 }}<lifedi-require></lifedi-require></label>
      <input class="form-control col-9" formControlName="choice_detail" type="text">
      <button mat-mini-fab class="img col-1" (click)="fileInput.click()" style="border-radius: 0; box-shadow: none;"
        [style.backgroundImage]="'url(\'../../../../assets/picture.png\')'">
        <input #fileInput type="file" accept=".png, .jpg, .jpeg" (change)="addChoiceMedia($event, c)"
          style="display:none;" />
      </button>
      <button mat-mini-fab class="img col-1" (click)="deleteChoice(multipleChoiceFormArray, i)"
        [style.backgroundImage]="'url(\'../../../../assets/remove.png\')'">
      </button>
      <div *ngIf="c.value.media.file_name" class="offset-1 col-11">
        <span style="display: inline;">
          {{ c.value.media.file_name }}
        </span>
        <button mat-icon-button style="display: inline;" (click)="deleteImgChoice(multipleChoiceFormArray, i)">
          <span class="text-danger">✖</span>
        </button>
      </div>
    </div>
  </div>
  <button mat-mini-fab class="img col-1" (click)="addChoiceAndImg(multipleChoiceFormArray)"
    [style.backgroundImage]="'url(\'../../../../assets/add.png\')'">
  </button>
</div>


<div *ngIf="modalData.isEdit" [formGroup]="multipleChoiceForm" class="mt-1">
  <div class="form-group row">
    <label class="col-2 col-form-label">คำถาม<lifedi-require></lifedi-require></label>
    <div class="col-9">
      <input type="text" class="form-control" id="question" formControlName="question" autocomplete="off"
        ngDefaultControl>
      <!-- <small *ngIf="!form.get('question').valid &&  form.get('question').touched"
        class="text-danger">
        กรุณากรอกข้อมูล
      </small> -->

      <span *ngIf="multipleChoiceForm.value.media?.file_name">
        <span style="display: inline;">
          {{ multipleChoiceForm.value.media.file_name }}
        </span>
        <button mat-icon-button style="display: inline;" (click)="deleteImgQuestion(multipleChoiceForm)">
          <span class="text-danger">✖</span>
        </button>
      </span>
      <!-- <span *ngIf="multipleChoiceForm.value.media?.file_name">{{ multipleChoiceForm.value.media.file_name }}</span> -->
    </div>
    <div class="col-1">
      <button mat-mini-fab class="img" (click)="fileInput.click()" style="border-radius: 0; box-shadow: none;"
        [style.backgroundImage]="'url(\'../../../../assets/multimedia.png\')'">
        <input #fileInput type="file" accept=".png, .jpg, .jpeg, .mp4, .mp3, .wav"
          (change)="addQuestionMedia($event, multipleChoiceForm)" style="display:none;" />
      </button>
    </div>
  </div>
  <div
    *ngIf="questionMediaType === 'mp4' || questionMediaType === 'mp3' || questionMediaType === 'wav' || questionMediaType === 'vdo' || questionMediaType === 'sound'"
    class="form-group row" formGroupName="media">
    <label class="col-6 col-form-label">จำนวนรอบที่วิดีโอ/เสียงสามารถเปิดซ้ำได้<lifedi-require></lifedi-require></label>
    <div class="col-2">
      <input [attr.disabled]="multipleChoiceForm.value.media.unlimit ? true : null" class="form-control"
        formControlName="time_again" type="number" min="0" width="100px"
        (change)="setTimeAgain(multipleChoiceForm, $event)">
    </div>
    <div class="col">
      <mat-checkbox id="unlimit" class="col-form-label" color="primary" formControlName="unlimit"
        (click)="clearValueDate(multipleChoiceForm)">
        ไม่จำกัดรอบ
      </mat-checkbox>
    </div>
  </div>

  <div *ngFor="let c of multipleChoiceFormArray.controls; let i = index" formArrayName="choices">
    <div [formGroupName]="i" class="form-group row">
      <label class="col-1 col-form-label">C{{ i+1 }}<lifedi-require></lifedi-require></label>
      <input class="form-control col-9" formControlName="choice_detail" type="text">
      <button mat-mini-fab class="img col-1" (click)="fileInput.click()" style="border-radius: 0; box-shadow: none;"
        [style.backgroundImage]="'url(\'../../../../assets/picture.png\')'">
        <input #fileInput type="file" accept=".png, .jpg, .jpeg" (change)="addChoiceMedia($event, c)"
          style="display:none;" />
      </button>
      <button mat-mini-fab class="img col-1" (click)="deleteChoice(multipleChoiceFormArray, i)"
        [style.backgroundImage]="'url(\'../../../../assets/remove.png\')'">
      </button>
      <div *ngIf="c.value.media.file_name" class="offset-1 col-11">
        <span style="display: inline;">
          {{ c.value.media.file_name }}
        </span>
        <button mat-icon-button style="display: inline;" (click)="deleteImgChoice(multipleChoiceFormArray, i)">
          <span class="text-danger">✖</span>
        </button>
      </div>
    </div>
  </div>

  <button mat-mini-fab class="img col-1" (click)="addChoiceAndImg(multipleChoiceFormArray)"
    [style.backgroundImage]="'url(\'../../../../assets/add.png\')'">
  </button>
</div>
